﻿import { Component, OnInit } from '@angular/core';
import { Chart, ChartData, Point, ChartColor } from 'chart.js';
import { CurrentConvocationMembers } from '../../../core/models/council-members/current-convocation-members';
import 'chartjs-plugin-datalabels';
import { SharedService } from '../../../shared/shared.service';
import { DropdownItem } from '../../../core/models/dropdown-item';
import { ConvocationDropdownItem } from '../../../core/models/administration/global-codes/convocation/convocation-dropdown-item';
import { LanguageService } from '../../../core/language/language.service';
import { CouncilMembersService } from '../../council-members/council-members.service';
import { Input } from '@angular/core';

export class NumberOfQuestionsAndAnswers {
    numberOfQuestions: number;
    numberOfAnswers: number;
}

export class ListByAnswerTime {
    id: number;
    questionsList: QuestionsModel[] = [];
}

export class QuestionsModel {
    id: number;
    answerTime: number;
    answerTimeFormatted: string;
}

export class NumberOfQuestionsByGender {
    sexId: number;
    sexName: string;
    number: number;
}

export class NumberOfQuestionsBySensitiveCategory {
    sensitiveCategoryId: number;
    sensitiveCategoryName: string;
    number: number;
}

export class NumberOfQuestionsByYearGroup {
    number: number;
    numberYear: number;
}

export class NumberOfAnsweredAndNotAnsweredQuestions {
    id: number;
    name: string;
    numberOfQuestions: number;
    numberOfAnswered: number;
    numberOfNotAnswered: number;
}

export class ListAverageAnswerTime {
    id: number;
    name: string;
    averageAnswerTime: number;
    averageAnswerTimeFormatted: string;
}
export class TitleLabels {
    NaslovBrojPitanja: string;
    NaslovZaVrijemeOdgovora: string;
    NaslovZaBrojPitanjaPoPolu: string;
    NaslovZaBrojPitanjaPoKategoriji: string;
    NaslovZaBrojPitanjaPoStarosnimGrupama: string;
    NaslovZaOdgovorenaINeodgovorenaPitanja: string;
    NaslovZaProsjecnoVrijemeOdgovora: string;
}

@Component({
    selector: 'app-question-statistic-chart',
    templateUrl: './question-statistic-chart.component.html'
})

export class QuestionStatisticChart implements OnInit {
    @Input() numberOfQuestionsAnswersList: NumberOfQuestionsAndAnswers;
    @Input() listByAnswerTime: ListByAnswerTime;
    @Input() numberOfQuestionsByGender: NumberOfQuestionsByGender[] = [];
    @Input() numberOfQuestionsBySensitiveCategory: NumberOfQuestionsBySensitiveCategory[] = [];
    @Input() numberOfQuestionsByYearGroup: NumberOfQuestionsByYearGroup[] = [];
    @Input() numberOfAnsweredAndNotAnsweredQuestions: NumberOfAnsweredAndNotAnsweredQuestions[] = [];
    @Input() listAverageAnswerTime: ListAverageAnswerTime[] = [];
    @Input() titleLabels: TitleLabels;
    private languageID: number;

    private myChartMemberQuestions: any;
    private myChartMemberAnswers: any;
    private myChartByGender: any;
    private myChartBySensitiveCategory: any;
    private myChartByYearGroup: any;
    private myChartAnsweredAndNotAnsweredQuestions: any;
    private myChartMemberListAverageAnswerTime: any;

    private membersQuestionsAnswersNames: string[] = [];
    private membersQuestionsByStatusNames: string[] = [];
    private questionsNumber: number[] = [];
    private answersNumber: number[] = [];
    private answeredQuestionsNumber: number[] = [];
    private notAnsweredQuestionsNumber: number[] = [];
    private listaPolova: string[] = [this._languageService.instant('muski_pol'), this._languageService.instant('zenski_pol'), this._languageService.instant('nepoznato')]
    private strPitanjaOdgovori: string[] = [this._languageService.instant('broj_pitanja'), this._languageService.instant('broj_odgovora')];

    private listaBojaZaClanove: string[] = ['rgba(255, 99, 132, 1)', 'rgba(54, 162, 235, 1)', 'rgba(255, 206, 86, 1)', 'rgba(75, 192, 192, 1)', 'rgba(153, 102, 255, 1)', 'rgba(255, 159, 64, 1)', 'rgba(255, 99, 132, 1)', 'rgba(54, 162, 235, 1)']
    private listaBojaZaClanoveStatusiPitanja: string[] = ['rgba(153, 102, 255, 1)', 'rgba(255, 159, 64, 1)', 'rgba(255, 99, 132, 1)', 'rgba(54, 162, 235, 1)', 'rgba(255, 99, 132, 1)', 'rgba(54, 162, 235, 1)', 'rgba(255, 206, 86, 1)', 'rgba(75, 192, 192, 1)']
    private listaBojaZaProsjecnoVrijemeOdg: string[] = ['rgba(255, 99, 132, 0.5)', 'rgba(54, 162, 235, 0.5)', 'rgba(255, 206, 86, 0.5)', 'rgba(75, 192, 192, 0.5)', 'rgba(153, 102, 255, 0.5)', 'rgba(255, 159, 64, 0.5)', 'rgba(255, 99, 132, 0.5)', 'rgba(54, 162, 235, 0.5)', 'rgba(255, 206, 86, 0.5)', 'rgba(75, 192, 192, 0.5)', 'rgba(153, 102, 255, 0.5)', 'rgba(255, 159, 64, 0.5)', 'rgba(255, 99, 132, 0.5)', 'rgba(54, 162, 235, 0.5)', 'rgba(255, 206, 86, 0.5)',
        'rgba(75, 192, 192, 0.5)', 'rgba(153, 102, 255, 0.5)', 'rgba(255, 159, 64, 0.5)', 'rgba(255, 99, 132, 0.5)', 'rgba(54, 162, 235, 0.5)', 'rgba(255, 206, 86, 0.5)', 'rgba(75, 192, 192, 0.5)', 'rgba(153, 102, 255, 0.5)', 'rgba(255, 159, 64, 0.5)', 'rgba(255, 159, 64, 0.5)', 'rgba(255, 99, 132, 0.5)', 'rgba(54, 162, 235, 0.5)', 'rgba(255, 206, 86, 0.5)', 'rgba(75, 192, 192, 0.5)', 'rgba(153, 102, 255, 0.5)', 'rgba(255, 159, 64, 0.5)',
        'rgba(255, 99, 132, 0.5)', 'rgba(54, 162, 235, 0.5)', 'rgba(255, 206, 86, 0.5)', 'rgba(75, 192, 192, 0.5)', 'rgba(153, 102, 255, 0.5)', 'rgba(255, 159, 64, 0.5)', 'rgba(255, 99, 132, 0.5)', 'rgba(54, 162, 235, 0.5)', 'rgba(255, 206, 86, 0.5)', 'rgba(75, 192, 192, 0.5)', 'rgba(153, 102, 255, 0.5)', 'rgba(255, 159, 64, 0.5)', 'rgba(255, 99, 132, 0.5)', 'rgba(54, 162, 235, 0.5)', 'rgba(255, 206, 86, 0.5)',
        'rgba(75, 192, 192, 0.5)', 'rgba(153, 102, 255, 0.5)', 'rgba(255, 159, 64, 0.5)', 'rgba(255, 99, 132, 0.5)', 'rgba(54, 162, 235, 0.5)', 'rgba(255, 206, 86, 0.5)', 'rgba(75, 192, 192, 0.5)', 'rgba(153, 102, 255, 0.5)', 'rgba(255, 159, 64, 0.5)', 'rgba(255, 159, 64, 0.5)', 'rgba(255, 99, 132, 0.5)', 'rgba(54, 162, 235, 0.5)', 'rgba(255, 206, 86, 0.5)', 'rgba(75, 192, 192, 0.5)', 'rgba(153, 102, 255, 0.5)', 'rgba(255, 159, 64, 0.5)'];
    private konacnaListaBojaZaClanove: string[] = [];
    private konacnaListaBojaZaClanoveStatusiPitanja: string[] = [];
    private konacnaListaBojaZaProsjecnoVrijemeOdg: string[] = [];


    private NaslovZaClanovePitanja = "";
    private NaslovZaVrijemeOdgovora = "";
    private NaslovZaProsjecnoVrijemeOdgovora = "";
    private NaslovZaBrojPitanjaPoPolu = this._languageService.instant('broj_pitanja_po_polu');
    private NaslovZaBrojPitanjaPoKategoriji = this._languageService.instant('broj_pitanja_po_kategoriji');
    private NaslovZaBrojPitanjaPoStarosnimGrupama = this._languageService.instant('broj_pitanja_po_starosnim_grupama');
    private NaslovZaOdgovorenaINeodgovorenaPitanja = this._languageService.instant('broj_odgovorenih_neodgovorenih_pitanja');
    private brojPitanja = this._languageService.instant('broj_pitanja');
    private brojOdgovora = this._languageService.instant('broj_odgovora');
    private brojOdgovorenih = this._languageService.instant('broj_odgovorenih');
    private brojNeodgovorenih = this._languageService.instant('broj_neodgovorenih');


    constructor(
        private _languageService: LanguageService,
        private _sharedService: SharedService) {
        this.languageID = this._languageService.selectedLanguageId;
    }

    ngOnInit() {


      
    }
    ngOnChanges() {

        this.NaslovZaClanovePitanja = this.titleLabels.NaslovBrojPitanja;
        this.NaslovZaVrijemeOdgovora = this.titleLabels.NaslovZaVrijemeOdgovora;
        this.NaslovZaProsjecnoVrijemeOdgovora = this.titleLabels.NaslovZaProsjecnoVrijemeOdgovora;

        this.getChartMembersQuestions();
        this.getChartMembersAnswers();
        this.getChartByGender();
        this.getChartBySensitiveCategory();
        this.getChartByYearGroup();
        this.getChartOfAnsweredAndNotAnsweredQuestions();
        this.getChartOfMemberListAverageAnswerTime();
    }


    getChartMembersQuestions() {
        if (this.myChartMemberQuestions) {
            this.myChartMemberQuestions.destroy();
        }

        var listaZaBrojPitanjaOdgovora: number[] = [];
        if (this.numberOfQuestionsAnswersList != null && this.numberOfQuestionsAnswersList.numberOfQuestions != null && this.numberOfQuestionsAnswersList.numberOfQuestions > 0) {
            listaZaBrojPitanjaOdgovora[0] = this.numberOfQuestionsAnswersList.numberOfQuestions;
            listaZaBrojPitanjaOdgovora[1] = this.numberOfQuestionsAnswersList.numberOfAnswers;
        }
        const elMonth = <HTMLCanvasElement>document.getElementById('myChartMemberQuestions');
        const ctx = elMonth.getContext('2d');

        this.myChartMemberQuestions = new Chart(ctx, {
            type: 'line',
            data: {
                labels: this.strPitanjaOdgovori,
                datasets: [{
                    backgroundColor: 'rgba(54, 162, 235, 1)',
                    data: listaZaBrojPitanjaOdgovora
                }]
            },
            options: {
                legend: {
                    display: false
                },
                title: {
                    display: true,
                    text: this.NaslovZaClanovePitanja
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            precision: 0
                        }
                    }]
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            var dataset = data.datasets[tooltipItem.datasetIndex];
                            var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                return previousValue + currentValue;
                            });
                            var currentValue = dataset.data[tooltipItem.index];
                            var percentage = Math.floor(((currentValue / total) * 100) + 0.5);
                            return currentValue + " (" + percentage + "%" + ")";
                        }
                    }
                },
                plugins: {
                    datalabels: {
                        align: 'center',
                        anchor: 'center',
                        backgroundColor: 'rgba(174,208,209, 0.5)',
                        //borderRadius: 4,
                        color: 'black',
                        formatter: (value, ctx) => {
                            if (value != null && value > 0) {
                                var dataset = ctx.chart.data.datasets[ctx.datasetIndex];
                                var sum = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                    return previousValue + currentValue;
                                });
                                let percentage = (value * 100 / (sum == 0 ? 1 : sum)).toFixed(2);
                                return value + "(" + percentage + "%)";
                            }

                            return null;
                        }
                    }
                }
            }
        });

        this.myChartMemberQuestions.update();
    }

    getChartMembersAnswers() {
        if (this.myChartMemberAnswers) {
            this.myChartMemberAnswers.destroy();
        }


        var listOfQuestionId: number[] = [];
        var listOfAnswerTime: number[] = [];
        var listOfAnswerTimeFormatted: string[] = [];

        if (this.listByAnswerTime != null && this.listByAnswerTime.questionsList.length > 0) {
            for (var j = 0; j < this.listByAnswerTime.questionsList.length; j++) {
                listOfQuestionId[j] = j + 1;
                listOfAnswerTime[j] = this.listByAnswerTime.questionsList[j].answerTime;
                listOfAnswerTimeFormatted[j] = this.listByAnswerTime.questionsList[j].answerTimeFormatted;
            }
        }

        const elMonth = <HTMLCanvasElement>document.getElementById('myChartMemberAnswers');
        const ctx = elMonth.getContext('2d');

        this.myChartMemberAnswers = new Chart(ctx, {
            type: 'line',
            data: {
                labels: listOfQuestionId,
                datasets: [{
                    backgroundColor: 'rgb(255, 99, 132)',
                    borderColor: 'rgb(255, 99, 132)',
                    data: listOfAnswerTime,
                    datalabels: listOfAnswerTimeFormatted,
                }]
            },
            options: {
                legend: {
                    display: false
                },
                title: {
                    display: true,
                    text: this.NaslovZaVrijemeOdgovora
                },
                scales: {
                    xAxes: [{
                        ticks: {
                            beginAtZero: true,
                            precision: 0
                        }
                    }],
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            precision: 0
                        }
                    }]
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            var dataset = data.datasets[tooltipItem.datasetIndex];

                            return dataset.datalabels[tooltipItem.index];
                        }
                    }
                },
                plugins: {
                    datalabels: {
                        align: 'center',
                        anchor: 'center',
                        backgroundColor: 'rgba(174,208,209, 0.5)',
                        color: 'black',
                        formatter: (value, ctx) => {
                            return ctx.chart.data.datasets[ctx.datasetIndex].datalabels[ctx.dataIndex];
                        }
                    }
                }
            }
        });

        this.myChartMemberAnswers.update();
    }

    getChartByGender() {
        if (this.myChartByGender) {
            this.myChartByGender.destroy();
        }

        var polovi: string[] = [];
        var brojPitanja: number[] = [];
        var brojPitanjaPoPolovima: number[] = [];
        if (this.numberOfQuestionsByGender != null) {
            for (var j = 0; j < this.numberOfQuestionsByGender.length; j++) {

                polovi[j] = this.numberOfQuestionsByGender[j].sexName;
                brojPitanja[j] = (Number)(this.numberOfQuestionsByGender[j].number);
                if (this.numberOfQuestionsByGender[j].sexId == 1)
                    brojPitanjaPoPolovima[j] = brojPitanja[j];
                if (this.numberOfQuestionsByGender[j].sexId == 2)
                    brojPitanjaPoPolovima[j] = brojPitanja[j];
                else
                    brojPitanjaPoPolovima[j] = brojPitanja[j];
            }
        }
        const elStatus = <HTMLCanvasElement>document.getElementById('myChartByGender');
        const ctxStatus = elStatus.getContext('2d');

        this.myChartByGender = new Chart(ctxStatus, {
            type: 'pie',

            data: {
                datasets: [{
                    data: brojPitanjaPoPolovima,
                    backgroundColor: ["#66B2FF", "#FF99CC", "rgb(229,255,204)"],
                    borderColor: ["#66B2FF", "#FF99CC", "rgb(229,255,204)"]

                }],
                labels: this.listaPolova
            },
            options: {
                title: {
                    display: true,
                    text: this.NaslovZaBrojPitanjaPoPolu
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            var dataset = data.datasets[tooltipItem.datasetIndex];
                            var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                return previousValue + currentValue;
                            });
                            var currentValue = dataset.data[tooltipItem.index];
                            var percentage = Math.floor(((currentValue / total) * 100) + 0.5);
                            return currentValue + " (" + percentage + "%" + ")";
                        }
                    }
                },
                plugins: {
                    datalabels: {
                        align: 'end',
                        anchor: 'center',
                        backgroundColor: 'rgba(174,208,209, 0.5)',
                        //borderRadius: 4,
                        color: 'black',
                        formatter: (value, ctx) => {

                            var dataset = ctx.chart.data.datasets[ctx.datasetIndex];
                            var sum = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                return previousValue + currentValue;
                            });
                            let percentage = (value * 100 / (sum == 0 ? 1 : sum)).toFixed(2);
                            return value + "(" + percentage + "%)";


                        }
                    }
                }
            }
        });
    }

    getChartBySensitiveCategory() {
        if (this.myChartBySensitiveCategory) {
            this.myChartBySensitiveCategory.destroy();
        }

        var osjetljiveKategorije: string[] = [];
        var brojPitanjaPoKategorijama: number[] = [];
        if (this.numberOfQuestionsBySensitiveCategory != null) {
            for (var j = 0; j < this.numberOfQuestionsBySensitiveCategory.length; j++) {
                if (this.numberOfQuestionsBySensitiveCategory[j].sensitiveCategoryId > 0) {
                    osjetljiveKategorije[j] = this.numberOfQuestionsBySensitiveCategory[j].sensitiveCategoryName;
                }
                else {
                    osjetljiveKategorije[j] = this._languageService.instant('nepoznato');
                }
                brojPitanjaPoKategorijama[j] = (Number)(this.numberOfQuestionsBySensitiveCategory[j].number);
                this.konacnaListaBojaZaClanoveStatusiPitanja[j] = this.listaBojaZaClanoveStatusiPitanja[j];
            }
        }
        const elOrg = <HTMLCanvasElement>document.getElementById('myChartBySensitiveCategory');
        const ctxOrg = elOrg.getContext('2d');

        this.myChartBySensitiveCategory = new Chart(ctxOrg, {
            type: 'bar',

            data: {
                labels: osjetljiveKategorije,
                datasets: [{

                    data: brojPitanjaPoKategorijama,

                    backgroundColor: this.konacnaListaBojaZaClanoveStatusiPitanja,
                    borderColor: this.konacnaListaBojaZaClanoveStatusiPitanja,
                    borderWidth: 1
                }]
            },

            options: {
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            precision: 0
                        }
                    }]
                    ,
                    xAxes: [{
                        ticks: {
                            minRotation: 0,
                            maxRotation: 0
                        }
                    }]
                },
                title: {
                    display: true,
                    text: this.NaslovZaBrojPitanjaPoKategoriji,
                },
                legend: {
                    display: false
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            var dataset = data.datasets[tooltipItem.datasetIndex];
                            var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                return previousValue + currentValue;
                            });
                            var currentValue = dataset.data[tooltipItem.index];
                            var percentage = Math.floor(((currentValue / total) * 100) + 0.5);
                            return currentValue + " (" + percentage + "%" + ")";
                        }
                    }
                },
                plugins: {
                    datalabels: {
                        align: 'bottom',
                        anchor: 'end',
                        backgroundColor: 'rgba(174,208,209, 0.5)',
                        //borderRadius: 4,
                        color: 'black',
                        formatter: (value, ctx) => {
                            if (value != null && value > 0) {
                                var dataset = ctx.chart.data.datasets[ctx.datasetIndex];
                                var sum = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                    return previousValue + currentValue;
                                });
                                let percentage = (value * 100 / (sum == 0 ? 1 : sum)).toFixed(2);
                                return value + "(" + percentage + "%)";
                            }

                            return null;
                        }
                    }
                }
            }

        });
    }

    getChartByYearGroup() {
        if (this.myChartByYearGroup) {
            this.myChartByYearGroup.destroy();
        }

        var starosneGrupe: string[] = [];
        var brojPitanjaPoStarosnimGrupama: number[] = [];
        var ispod18: number = 0;
        var od18do35: number = 0;
        var od35do55: number = 0;
        var preko55: number = 0;
        var nepoznato: number = 0;

        if (this.numberOfQuestionsByYearGroup != null) {
            for (var j = 0; j < this.numberOfQuestionsByYearGroup.length; j++) {
                if (this.numberOfQuestionsByYearGroup[j].numberYear > 0 && this.numberOfQuestionsByYearGroup[j].numberYear < 18) {
                    ispod18 += this.numberOfQuestionsByYearGroup[j].number;
                }
                if (this.numberOfQuestionsByYearGroup[j].numberYear >= 18 && this.numberOfQuestionsByYearGroup[j].numberYear < 36) {
                    od18do35 += this.numberOfQuestionsByYearGroup[j].number;
                }
                if (this.numberOfQuestionsByYearGroup[j].numberYear >= 36 && this.numberOfQuestionsByYearGroup[j].numberYear < 56) {
                    od35do55 += this.numberOfQuestionsByYearGroup[j].number;
                }
                if (this.numberOfQuestionsByYearGroup[j].numberYear >= 56) {
                    preko55 += this.numberOfQuestionsByYearGroup[j].number;
                }
                if (this.numberOfQuestionsByYearGroup[j].numberYear == 0) {
                    nepoznato += this.numberOfQuestionsByYearGroup[j].number;
                }
            }
            starosneGrupe[0] = this._languageService.instant('Ispod_18');
            starosneGrupe[1] = '18-35';
            starosneGrupe[2] = '36-55';
            starosneGrupe[3] = this._languageService.instant('Preko_55');
            starosneGrupe[4] = this._languageService.instant('nepoznato');
            brojPitanjaPoStarosnimGrupama[0] = ispod18;
            brojPitanjaPoStarosnimGrupama[1] = od18do35;
            brojPitanjaPoStarosnimGrupama[2] = od35do55;
            brojPitanjaPoStarosnimGrupama[3] = preko55;
            brojPitanjaPoStarosnimGrupama[4] = nepoznato;
        }
        const elOrg = <HTMLCanvasElement>document.getElementById('myChartByYearGroup');
        const ctxOrg = elOrg.getContext('2d');

        this.myChartByYearGroup = new Chart(ctxOrg, {
            type: 'bar',

            data: {
                labels: starosneGrupe,
                datasets: [{

                    data: brojPitanjaPoStarosnimGrupama,

                    backgroundColor: this.listaBojaZaClanove,
                    borderColor: this.listaBojaZaClanove,
                    borderWidth: 1
                }]
            },

            options: {
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            precision: 0
                        }
                    }]
                    ,
                    xAxes: [{
                        ticks: {
                            minRotation: 0,
                            maxRotation: 0
                        }
                    }]
                },
                title: {
                    display: true,
                    text: this.NaslovZaBrojPitanjaPoStarosnimGrupama,
                },
                legend: {
                    display: false
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            var dataset = data.datasets[tooltipItem.datasetIndex];
                            var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                return previousValue + currentValue;
                            });
                            var currentValue = dataset.data[tooltipItem.index];
                            var percentage = Math.floor(((currentValue / total) * 100) + 0.5);
                            return currentValue + " (" + percentage + "%" + ")";
                        }
                    }
                },
                plugins: {
                    datalabels: {
                        align: 'bottom',
                        anchor: 'end',
                        backgroundColor: 'rgba(174,208,209, 0.5)',
                        //borderRadius: 4,
                        color: 'black',
                        formatter: (value, ctx) => {
                            if (value != null && value > 0) {
                                var dataset = ctx.chart.data.datasets[ctx.datasetIndex];
                                var sum = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                    return previousValue + currentValue;
                                });
                                let percentage = (value * 100 / (sum == 0 ? 1 : sum)).toFixed(2);
                                return value + "(" + percentage + "%)";
                            }

                            return null;
                        }
                    }
                }
            }

        });
    }

    getChartOfAnsweredAndNotAnsweredQuestions() {
        if (this.myChartAnsweredAndNotAnsweredQuestions) {
            this.myChartAnsweredAndNotAnsweredQuestions.destroy();
        }

        var vijecnici: string[] = [];
        var brojOdg: number[] = [];
        var brojNeodg: number[] = [];
        if (this.numberOfAnsweredAndNotAnsweredQuestions != null) {
            for (var j = 0; j < this.numberOfAnsweredAndNotAnsweredQuestions.length; j++) {

                vijecnici[j] = this.numberOfAnsweredAndNotAnsweredQuestions[j].name;
                brojOdg[j] = (Number)(this.numberOfAnsweredAndNotAnsweredQuestions[j].numberOfAnswered);
                brojNeodg[j] = (Number)(this.numberOfAnsweredAndNotAnsweredQuestions[j].numberOfNotAnswered);
                this.konacnaListaBojaZaClanove[j] = this.listaBojaZaClanove[j];
            }
        }

        const elMonth = <HTMLCanvasElement>document.getElementById('myChartAnsweredAndNotAnsweredQuestions');
        const ctx = elMonth.getContext('2d');

        this.myChartAnsweredAndNotAnsweredQuestions = new Chart(ctx, {
            type: 'horizontalBar',
            data: {
                labels: vijecnici,
                datasets: [{
                    label: this.brojOdgovorenih,
                    data: brojOdg,
                    backgroundColor: 'rgb(255,204,204,0.7)',
                }, {
                    label: this.brojNeodgovorenih,
                    data: brojNeodg,
                    backgroundColor: 'rgb(255,229,204,0.7)',
                }],
            },
            options: {
                scales: {
                    xAxes: [{
                        stacked: true,
                        ticks: {
                            beginAtZero: true,
                            precision: 0
                        },
                    }],
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            mirror: true
                        },
                        stacked: true
                    }]
                },
                legend: {
                    display: true
                },
                title: {
                    display: true,
                    text: this.NaslovZaOdgovorenaINeodgovorenaPitanja
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            var dataset = data.datasets[tooltipItem.datasetIndex];
                            var total = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                                return previousValue + currentValue;
                            });
                            var currentValue = dataset.data[tooltipItem.index];
                            var percentage = Math.floor(((currentValue / total) * 100) + 0.5);
                            //return currentValue + " (" + percentage + "%" + ")";
                            return currentValue;
                        }
                    }
                },
                //plugins: {
                //    datalabels: {
                //        align: 'center',
                //        anchor: 'center',
                //        backgroundColor: 'rgba(174,208,209, 0.5)',
                //        //borderRadius: 4,
                //        color: 'black',
                //        formatter: (value, ctx) => {
                //            if (value != null && value > 0) {
                //                var dataset = ctx.chart.data.datasets[ctx.datasetIndex];
                //                var sum = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                //                    return previousValue + currentValue;
                //                });
                //                let percentage = (value * 100 / (sum == 0 ? 1 : sum)).toFixed(2);
                //                return value + "(" + percentage + "%)";
                //            }

                //            return null;
                //        }
                //    }
                //}
                plugins: {
                    datalabels: {
                        align: 'end',
                        anchor: 'start',
                        backgroundColor: 'rgba(174,208,209, 0.5)',
                        //borderRadius: 4,
                        color: 'black',
                        //formatter: (value, ctx) => {
                        //    if (value != null && value > 0) {
                        //        var dataset = ctx.chart.data.datasets[ctx.datasetIndex];
                        //        var sum = dataset.data.reduce(function (previousValue, currentValue, currentIndex, array) {
                        //            return previousValue + currentValue;
                        //        });
                        //        let percentage = (value * 100 / (sum == 0 ? 1 : sum)).toFixed(2);
                        //        return value + "(" + percentage + "%)";
                        //    }

                        //    return null;
                        //}
                        formatter: (value, ctx) => {
                            const otherDatasetIndex = ctx.datasetIndex === 0 ? 1 : 0;
                            const total =
                                ctx.chart.data.datasets[otherDatasetIndex].data[ctx.dataIndex] + value;
                            return null;//value == 0 ? `0(0%)` : `${value}(${(value / total * 100).toFixed(0)}%)`;
                        }
                    }
                }
            }
        });

        this.myChartAnsweredAndNotAnsweredQuestions.update();
    }

    getChartOfMemberListAverageAnswerTime() {
        if (this.myChartMemberListAverageAnswerTime) {
            this.myChartMemberListAverageAnswerTime.destroy();
        }

        var vijecnici: string[] = [];
        var prosjecnoVrijemeOdgovora: number[] = [];
        var prosjecnoVrijemeOdgovoraFormatted: string[] = [];
        if (this.listAverageAnswerTime != null) {
            for (var j = 0; j < this.listAverageAnswerTime.length; j++) {
                vijecnici[j] = this.listAverageAnswerTime[j].name;
                prosjecnoVrijemeOdgovora[j] = (Number)(this.listAverageAnswerTime[j].averageAnswerTime);
                prosjecnoVrijemeOdgovoraFormatted[j] = this.listAverageAnswerTime[j].averageAnswerTimeFormatted;
                this.konacnaListaBojaZaProsjecnoVrijemeOdg[j] = this.listaBojaZaProsjecnoVrijemeOdg[j];
            }
        }
        const elMonth = <HTMLCanvasElement>document.getElementById('myChartMemberListAverageAnswerTime');
        const ctx = elMonth.getContext('2d');

        this.myChartMemberListAverageAnswerTime = new Chart(ctx, {
            type: 'horizontalBar',
            data: {
                labels: vijecnici,
                datasets: [{
                    data: prosjecnoVrijemeOdgovora,
                    datalabels: prosjecnoVrijemeOdgovoraFormatted,
                    backgroundColor: this.konacnaListaBojaZaProsjecnoVrijemeOdg,
                    borderColor: this.konacnaListaBojaZaProsjecnoVrijemeOdg,
                    borderWidth: 1
                }]
            },
            options: {
                scales: {
                    xAxes: [{
                        stacked: true,
                        ticks: {
                            beginAtZero: true,
                            precision: 0
                        },
                    }],
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            mirror: true
                        },
                        stacked: true
                    }]
                },
                legend: {
                    display: false
                },
                title: {
                    display: true,
                    text: this.NaslovZaProsjecnoVrijemeOdgovora
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            var dataset = data.datasets[tooltipItem.datasetIndex];
                            return null;// dataset.datalabels[tooltipItem.datasetIndex];
                        }
                    }
                    
                },
                plugins: {
                    datalabels: {
                        align: 'center',
                        anchor: 'center',
                        backgroundColor: 'rgba(174,208,209, 0.5)',
                        color: 'black',
                        formatter: (value, ctx) => {
                            if (value != null && value > 0) {
                                return null;// ctx.chart.data.datasets[ctx.dataIndex].datalabels[ctx.dataIndex];
                            }
                           return null;
                        }
                    }
                }
            }
        });
        


        this.myChartMemberListAverageAnswerTime.update();
    }

}